/**
 * PMGW Custom JavaScript
 * Dynamic Shipping Calculation and Free Shipping Bar
 * Simple approach with polling and direct DOM monitoring
 */

(function() {
  'use strict';

  var shippingCalculator = null;

  // Wait for theme to be ready
  document.addEventListener('DOMContentLoaded', function() {
    initShippingCalculator();
  });

  function initShippingCalculator() {
    shippingCalculator = new ShippingCalculator();
    shippingCalculator.init();
  }

  function ShippingCalculator() {
    this.shippingPrice = 599; // 5.99 in cents
    this.freeShippingThreshold = 5900; // 59.00 in cents
    this.lastSubtotal = null;
    this.pollingInterval = null;
  }

  ShippingCalculator.prototype = {
    init: function() {
      this.startPolling();
      this.updateFreeShippingBar();
      this.updateShippingCosts();
      this.showFreeShippingBar();
    },

    startPolling: function() {
      // Poll every 500ms to check for changes
      this.pollingInterval = setInterval(function() {
        this.checkForUpdates();
      }.bind(this), 500);
    },

    checkForUpdates: function() {
      var currentSubtotal = this.getCartSubtotal();
      if (currentSubtotal !== null && currentSubtotal !== this.lastSubtotal) {
        this.lastSubtotal = currentSubtotal;
        this.updateFreeShippingBar();
        this.updateShippingCosts();
      }
    },

    showFreeShippingBar: function() {
      // The bar is already visible if cart is not empty (Liquid condition)
      // Just update the content
      this.updateFreeShippingBar();
    },

    // Force update method for manual triggering
    forceUpdate: function() {
      this.updateFreeShippingBar();
      this.updateShippingCosts();
    },

    getCartSubtotal: function() {
      // Try to get from cart items data attribute first (most reliable)
      var cartDrawer = document.querySelector('#CartDrawer');
      if (cartDrawer) {
        var cartItems = cartDrawer.querySelector('.cart__items');
        if (cartItems && cartItems.dataset.cartSubtotal) {
          var subtotal = parseInt(cartItems.dataset.cartSubtotal);
          console.log('Cart subtotal from data attribute:', subtotal);
          return subtotal;
        }
      }

      // Try to get from theme's subtotal element
      var themeSubtotal = document.querySelector('[data-subtotal]');
      if (themeSubtotal) {
        var subtotalText = themeSubtotal.textContent;
        console.log('Subtotal text:', subtotalText);
        
        // Better regex for European number format
        var match = subtotalText.match(/[\d,]+\.?\d*/);
        if (match) {
          var amount = parseFloat(match[0].replace(',', '.'));
          var cents = Math.round(amount * 100);
          console.log('Parsed amount:', amount, 'Cents:', cents);
          return cents;
        }
      }

      return null;
    },

    updateFreeShippingBar: function() {
      var cartSubtotal = this.getCartSubtotal();
      if (cartSubtotal === null) return;

      var freeShippingBar = document.querySelector('#freeShippingBar');
      if (!freeShippingBar) return;

      // Bar is visible by default if cart is not empty (Liquid condition)
      // Just update the content
      var progressBar = freeShippingBar.querySelector('[data-progress-bar]');
      var textElement = freeShippingBar.querySelector('[data-free-shipping-text]');

      if (!progressBar || !textElement) return;

      if (cartSubtotal >= this.freeShippingThreshold) {
        // Free shipping achieved
        progressBar.style.width = '100%';
        textElement.innerHTML = '<span class="HighlightText">🎉 Du erhältst kostenlosen Versand!</span>';
      } else {
        // Show progress towards free shipping
        var remaining = this.freeShippingThreshold - cartSubtotal;
        var progress = (cartSubtotal / this.freeShippingThreshold) * 100;
        
        progressBar.style.width = progress + '%';
        
        var remainingFormatted = this.formatMoney(remaining);
        textElement.innerHTML = 'Dir fehlen <span class="HighlightText">' + remainingFormatted + '</span> zum kostenlosen Versand!';
      }
    },

    updateShippingCosts: function() {
      var cartSubtotal = this.getCartSubtotal();
      if (cartSubtotal === null) {
        console.log('No cart subtotal found');
        return;
      }

      console.log('Updating shipping costs for subtotal:', cartSubtotal);

      var shippingContainer = document.querySelector('#shippingAndTotal');
      if (!shippingContainer) {
        console.log('Shipping container not found');
        return;
      }

      var subtotalElement = shippingContainer.querySelector('[data-cart-subtotal]');
      var shippingElement = shippingContainer.querySelector('[data-shipping-cost]');
      var totalElement = shippingContainer.querySelector('[data-cart-total]');

      if (!subtotalElement || !shippingElement || !totalElement) {
        console.log('Shipping elements not found');
        return;
      }

      // Update subtotal
      subtotalElement.textContent = this.formatMoney(cartSubtotal);

      // Calculate shipping and total
      var isFreeShipping = cartSubtotal >= this.freeShippingThreshold;
      var shippingCost = isFreeShipping ? 0 : this.shippingPrice;
      var totalCost = cartSubtotal + shippingCost;

      console.log('Free shipping:', isFreeShipping, 'Shipping cost:', shippingCost, 'Total cost:', totalCost);

      // Update shipping cost display
      if (isFreeShipping) {
        shippingElement.innerHTML = '<span class="HighlightText">Kostenlos</span>';
      } else {
        shippingElement.textContent = this.formatMoney(shippingCost);
      }

      // Update total
      totalElement.textContent = this.formatMoney(totalCost);
    },

    formatMoney: function(cents) {
      // Use theme's currency formatting if available
      if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }
      // Fallback formatting with proper European format
      var amount = (cents / 100).toFixed(2);
      return '€' + amount.replace('.', ',');
    }
  };

  // Make it globally accessible for manual updates
  window.pmgwShippingCalculator = shippingCalculator;
  
  // Also expose a simple update function
  window.updateShippingInfo = function() {
    if (shippingCalculator) {
      shippingCalculator.forceUpdate();
    }
  };

  /*============================================================================
    Cart Item Delete Functionality
    ==============================================================================*/
  function initCartDeleteButtons() {
    // Use event delegation for dynamically added items
    document.addEventListener('click', function(e) {
      var deleteButton = e.target.closest('[data-cart-delete]');
      if (!deleteButton) return;

      e.preventDefault();
      e.stopPropagation();

      var itemKey = deleteButton.getAttribute('data-cart-delete');
      if (!itemKey) return;

      // Remove item from cart using theme's cart API
      if (typeof theme !== 'undefined' && theme.cart && theme.cart.changeItem) {
        theme.cart.changeItem(itemKey, 0)
          .then(function() {
            // Trigger cart rebuild
            document.dispatchEvent(new CustomEvent('cart:build'));
            
            // Update shipping info
            if (shippingCalculator) {
              setTimeout(function() {
                shippingCalculator.forceUpdate();
              }, 300);
            }
          })
          .catch(function(error) {
            console.error('Error removing item from cart:', error);
          });
      } else {
        // Fallback: use direct URL
        window.location.href = '/cart/change?id=' + itemKey + '&quantity=0';
      }
    });
  }

  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', function() {
    initCartDeleteButtons();
    initCartOpenHandlers();
  });

  // Update header elements after theme is fully loaded
  document.addEventListener('page:loaded', function() {
    updateCartHeaderElements();
  });

  /*============================================================================
    Cart Open Handlers - Update Free Shipping Bar and Drawer Message
    Works exactly like the footer - CSS handles visibility via is-empty class
    ==============================================================================*/
  function updateCartHeaderElements() {
    // CSS handles visibility via .drawer:not(.is-empty) selector (like footer)
    // We just need to update the content
    
    // Update free shipping bar
    if (shippingCalculator) {
      shippingCalculator.showFreeShippingBar();
      shippingCalculator.updateShippingCosts();
    }
    
    // Show drawer message
    var cartDrawer = document.querySelector('#CartDrawer');
    if (cartDrawer) {
      var drawerMessage = cartDrawer.querySelector('.Drawer__Message');
      if (drawerMessage) {
        var drawer = cartDrawer.closest('.drawer');
        if (drawer && !drawer.classList.contains('is-empty')) {
          drawer.classList.add('show-message');
        }
      }
    }
  }

  function initCartOpenHandlers() {
    // Listen for cart:updated event - this is called after buildCart() updates the cart
    // This is the main event that updates the cart, just like the footer
    document.addEventListener('cart:updated', function() {
      updateCartHeaderElements();
    });

    // Also listen for cart:build as backup
    document.addEventListener('cart:build', function() {
      setTimeout(function() {
        updateCartHeaderElements();
      }, 200);
    });

    // Listen for drawer open - update when drawer opens
    document.addEventListener('drawerOpen', function() {
      setTimeout(function() {
        updateCartHeaderElements();
      }, 100);
    });

    // Listen for drawerOpen.CartDrawer specifically
    document.addEventListener('drawerOpen.CartDrawer', function() {
      setTimeout(function() {
        updateCartHeaderElements();
      }, 100);
    });
  }

})();

/*============================================================================
  Supplement Kombination Accordion
  Echtes Accordion - nur ein Produkt gleichzeitig offen
  ==============================================================================*/
(function() {
  'use strict';

  function initSuppAccordions() {
    var accordions = document.querySelectorAll('.supp-accordion');
    
    accordions.forEach(function(host) {
      host.addEventListener('toggle', function(e) {
        var t = e.target;
        if (t.tagName !== 'DETAILS' || !t.open) return;
        host.querySelectorAll('details').forEach(function(d) {
          if (d !== t) d.open = false;
        });
      }, true);
    });
  }

  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', initSuppAccordions);

  // Re-initialize when Shopify section is loaded/reloaded (for Theme Editor)
  document.addEventListener('shopify:section:load', initSuppAccordions);
})();
